import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import InputRejected from '../InputRejected';
import useEnabler from '../../../hooks/useEnabler';

import rfcIsValid from './validator';
import rfcFormatter from './formatter';

const ERROR_MESSAGE = 'RFC incompleto o con formato incorrecto';

const InputRFC = ({
  value, onChange, isEmpty, ...props
}) => {
  const {
    isEnabled: isError,
    enable: enableError,
    disable: disableError,
  } = useEnabler();

  const handleOnChange = useCallback((event) => {
    const { target } = event;
    const { value: _value } = target; // XAXX010101000

    const newValue = rfcFormatter(_value);

    if (rfcIsValid(newValue)) {
      target.setCustomValidity('');
      disableError();
    } else {
      target.setCustomValidity(ERROR_MESSAGE);
      enableError();
    }

    onChange(event, newValue);
  }, [onChange, enableError, disableError]);

  return (
    <InputRejected
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      isValid={rfcIsValid(value)}
      value={rfcFormatter(value)}
      onChange={handleOnChange}
      isEmpty={isEmpty}
      error={isError}
      helperText={isError ? ERROR_MESSAGE : ''}
    />
  );
};

InputRFC.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  isEmpty: PropTypes.any,
};

InputRFC.defaultProps = {
  isEmpty: undefined,
};

export default memo(InputRFC);
